/**
 * Legal Hub JavaScript
 * タブ切り替え・目次生成・スムーススクロール
 */

class LegalHub {
  constructor() {
    this.tabs = [];
    this.panels = [];
    this.tocContainer = null;
    this.currentTab = 'terms';
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.setupElements();
      this.generateTOC();
      this.attachEventListeners();
      this.handleHash();
    });
  }

  setupElements() {
    this.tabs = Array.from(document.querySelectorAll('.legal-hub__tab'));
    this.panels = Array.from(document.querySelectorAll('.legal-hub__panel'));
    this.tocContainer = document.querySelector('.legal-hub__toc');
  }

  generateTOC() {
    if (!this.tocContainer) return;

    // 現在のアクティブパネルのセクションを取得
    const activePanel = document.querySelector('.legal-hub__panel--active');
    if (!activePanel) return;

    this.updateTOC(activePanel);
  }

  updateTOC(panel) {
    if (!this.tocContainer) return;

    // 目次をクリア
    this.tocContainer.innerHTML = '';

    // パネル内のセクションを取得
    const sections = panel.querySelectorAll('section[id]');

    sections.forEach(section => {
      const heading = section.querySelector('h2');
      if (!heading) return;

      const link = document.createElement('a');
      link.href = `#${section.id}`;
      link.className = 'legal-hub__toc-link';
      link.textContent = heading.textContent;
      link.addEventListener('click', (e) => this.handleTOCClick(e, section.id));

      this.tocContainer.appendChild(link);
    });

    // スクロール位置に応じて目次のアクティブ状態を更新
    this.setupScrollSpy();
  }

  attachEventListeners() {
    // タブクリックイベント
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab));
    });

    // ブラウザの戻る/進むボタン対応
    window.addEventListener('popstate', () => this.handleHash());
  }

  handleTabClick(tab) {
    const tabName = tab.dataset.tab;
    if (!tabName) return;

    this.switchTab(tabName);

    // URLハッシュを更新（履歴に追加）
    history.pushState({ tab: tabName }, '', `#${tabName}`);
  }

  switchTab(tabName) {
    this.currentTab = tabName;

    // すべてのタブを非アクティブに
    this.tabs.forEach(t => {
      t.classList.remove('legal-hub__tab--active');
      t.setAttribute('aria-selected', 'false');
    });

    // すべてのパネルを非表示に
    this.panels.forEach(p => {
      p.classList.remove('legal-hub__panel--active');
      p.setAttribute('hidden', '');
    });

    // 指定されたタブをアクティブに
    const activeTab = this.tabs.find(t => t.dataset.tab === tabName);
    if (activeTab) {
      activeTab.classList.add('legal-hub__tab--active');
      activeTab.setAttribute('aria-selected', 'true');
    }

    // 指定されたパネルを表示
    const activePanel = document.getElementById(`panel-${tabName}`);
    if (activePanel) {
      activePanel.classList.add('legal-hub__panel--active');
      activePanel.removeAttribute('hidden');

      // 目次を更新
      this.updateTOC(activePanel);

      // ページトップにスクロール
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  handleHash() {
    const hash = window.location.hash.slice(1);

    // ハッシュがタブ名の場合
    if (hash && this.tabs.some(t => t.dataset.tab === hash)) {
      this.switchTab(hash);
      return;
    }

    // ハッシュがセクションIDの場合
    if (hash && hash.includes('-')) {
      const [tabName] = hash.split('-');
      if (this.tabs.some(t => t.dataset.tab === tabName)) {
        this.switchTab(tabName);
        setTimeout(() => {
          const section = document.getElementById(hash);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    }
  }

  handleTOCClick(e, sectionId) {
    e.preventDefault();

    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // URLハッシュを更新
      history.pushState({ section: sectionId }, '', `#${sectionId}`);

      // 目次のアクティブ状態を更新
      this.updateActiveTOCLink(sectionId);
    }
  }

  setupScrollSpy() {
    const options = {
      root: null,
      rootMargin: '-100px 0px -80% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.updateActiveTOCLink(entry.target.id);
        }
      });
    }, options);

    const activePanel = document.querySelector('.legal-hub__panel--active');
    if (!activePanel) return;

    const sections = activePanel.querySelectorAll('section[id]');
    sections.forEach(section => observer.observe(section));
  }

  updateActiveTOCLink(sectionId) {
    const tocLinks = this.tocContainer.querySelectorAll('.legal-hub__toc-link');

    tocLinks.forEach(link => {
      link.classList.remove('legal-hub__toc-link--active');

      if (link.getAttribute('href') === `#${sectionId}`) {
        link.classList.add('legal-hub__toc-link--active');
      }
    });
  }
}

// インスタンス化
new LegalHub();
